
export const SAVE_LAST_STAGE_INDEX = 'SAVE_LAST_STAGE_INDEX'
export const SAVE_LAST_PACKAGE_INDEX = 'SAVE_LAST_PACKAGE_INDEX'
export const SAVE_LAST_SCORE = 'SAVE_LAST_SCORE'
export const SAVE_SCORES = 'SAVE_SCORES'
export const SAVE_WORDS = 'SAVE_WORDS'
export const SAVE_SENTENCES = 'SAVE_SENTENCES'
export const UPDATE_SCORE = 'UPDATE_SCORE'


export const saveLastStageIndex = (index) => ({
    type: SAVE_LAST_STAGE_INDEX,
    index,
})

export const saveLastPackageIndex = (index) => ({
    type: SAVE_LAST_PACKAGE_INDEX,
    index,
})

export const saveLastScore = (score) => ({
    type: SAVE_LAST_SCORE,
    score
})

export const saveScores = (scores) => ({
    type: SAVE_SCORES,
    scores,
})

export const saveWords = (words) => ({
    type: SAVE_WORDS,
    words,
})

export const saveSentences = (sentences) => ({
    type: SAVE_SENTENCES,
    sentences,
})

export const updateScore = (score, lessonId, stageIndex) => ({
    type: UPDATE_SCORE,
    lessonId,
    stageIndex,
    score,
})